import { FC } from "react";
import { Box, Button, Toolbar, Typography, useTheme } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

export interface IBlock17BSetupFieldsPanelHeader{
    openNew: () => void;
    // selectedFieldPanelLabel: string;
}

export const Block17BSetupFieldsPanelHeader: FC<IBlock17BSetupFieldsPanelHeader> = ({
    openNew,
    // selectedFieldPanelLabel,
}) => {
    const theme = useTheme();
    return (
        <Box>
            <Toolbar
                sx={{
                    // justifyContent: "end",
                    padding: "0!important",
                }}
            >
                <>
                    <Typography
                        sx={{
                            fontSize: "1.2rem !important",
                            fontWeight: "bold",
                        }}
                    >
                        {/* {selectedFieldPanelLabel} */}
                    </Typography>
                    
                    <Button
                        size="medium"
                        startIcon={<AddIcon />}
                        variant="contained"
                        sx={{
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.common.white,
                            "&:hover": {
                                backgroundColor: theme.palette.primary.dark,
                            },
                            textTransform: "none",
                            marginLeft: "auto",
                        }}
                        onClick={openNew}
                    >
                        <Typography>Add</Typography>
                    </Button>
                </>
            </Toolbar>
        </Box>
    );
};
